import newChart from "./newChart";
import linChart from "./linChart";
import Datepicker from "@/components/Datepicker/Datepicker.vue";
import Navigate from "@/components/Navigate/Navigate.vue";
import CustomDropdownBorder from "@/components/CustomDropdownBorder/CustomDropdownBorder.vue";
import changeProject from "@/views/changeProject/changeProject.vue";
import UpdateSettings from "@/views/UpdateSettings/UpdateSettings.vue";
import generalChart from "./generalChart";
import moment from 'moment';
import axios from "axios";
import Preloader from "../../components/Preloader/Preloader.vue";
import api_requests from "../../store/api/api_requests";
import NoData from "@/components/__new_ui_kit/Table/NoData";

export default {
    name: "StatisticsPage",
    components: {
        newChart, linChart, CustomDropdownBorder, Datepicker, Navigate, changeProject, UpdateSettings, generalChart, Preloader, NoData
    },
    data() {
        return {
            currentId: this.$route.params.id,
            doughnutIsEmpty: false,
            generalChartIsEmpty: false,
            days: [],
            vals: [],
            succcessGeneral: [],
            flag: true,
            activePage: 1,
            labels: [["Success"],["Failure"]],
            stat: false,
            statisticItem: [
                {id: 1, name: 'Success'},
                {id: 2, name: 'Visits'}
            ],
            //dropdown with periods for "Line Chart Statistic"
            periods: [
                {id: 1, name: '1 months'},
                {id: 2, name: '2 months'},
                {id: 3, name: '6 months'},
            ],
            stat_periods: [
                // {id: 1, name: 1},
                // {id: 2, name: 2},
                // {id: 3, name: 6},
                {id: 1, name: 'Today', pluck: 'today'},
                {id: 2, name: 'Yesterday', pluck: 'yesterday'},
                {id: 3, name: 'Last 7 Days', pluck: 'last_7_days'},
                {id: 4, name: 'This Month', pluck: 'this_month'},
                {id: 5, name: 'Last Month', pluck: 'last_month'},
            ],
            dateToLineChart: [],
            // datePeriod: {id: 1, name: 1},
            datePeriod: {id: 5, name: 'Last Month'},
            typeVisit: {id: 1, name: 'Visits'},
            allDate: [],
            tabAnalytics: '',
            vis: '',
            dateToLineChartVisits: [],
            dateToLineChartSuccess: []
        }
    },
    props: {
        propTabAnalytics: String
    },
    created() {
        this.onCreated();
    },
    methods: {
        onCreated() {
            this.getDate()
                .then(() => {
                    this.loadingStatistics()
                        .then(res => {
                            this.allDay = res
                            this.change(this.allDay)
                        })
                    this.tabAnalytics = this.$props.propTabAnalytics === 'true'
                })
        },
        updateTable() {
            this.onCreated();
        },
        moment: function () {
            return moment();
        },
        checkEmptyChart(args) {
          const {type, isEmpty} = args
          if (type === 'doughnut') {
            this.doughnutIsEmpty = isEmpty
          }
          else {
            this.generalChartIsEmpty = isEmpty
          }
        },
        statistic_v3(period) {
            return new Promise((resolve) => {
                api_requests.get_statistics_v3({id: this.$route.params.id, period: period})
                    .then((response) => {
                        let list = response.data.data
                        this.vals = response.data.failure_vals
                        this.succcessGeneral = response.data.success_vals
                        let stats = []
                        let list_num = []
                        list.map((item) => {
                            list_num.push(Number(item[0] + '.' + String(item[1])))
                        })
                        this.days = list_num
                        this.stat = [response.data.diagram_success_vals, response.data.diagram_failures_vals]
                        resolve()
                    })
            })
        },
        getDate(period) {
            return new Promise((resolve) => {
                api_requests.get_statistics({id: this.$route.params.id, period: period})
                    .then((response) => {
                        let list = response.data.data
                        this.vals = response.data.failure_vals
                        this.succcessGeneral = response.data.success_vals
                        let stats = []
                        let list_num = []
                        list.map((item) => {
                            list_num.push(Number(item[0] + '.' + String(item[1])))
                        })
                        this.days = list_num
                        this.stat = [response.data.diagram_success_vals, response.data.diagram_failures_vals]
                        resolve()
                    })
            })
        },
        switchingTabs(name) {
            this.tabAnalytics = Boolean(name === 'analytics')
        },
        methodToRunOnSelect(payload) {
            this.selectedOption = payload;
            this.department = payload;
        },
        change() {
            this.flag = !this.flag;
            this.dateToLineChart = this.convertDateToLineChart(this.allDay, this.datePeriod.id, this.typeVisit.id)
            this.dateToLineChartVisits = this.convertDateToLineChart(this.allDay, this.datePeriod.id, 1)
            this.dateToLineChartSuccess = this.convertDateToLineChart(this.allDay, this.datePeriod.id, 2)
            setTimeout(() => this.flag = !this.flag, 0);
        },
        changeType(payload) {
            this.typeVisit = payload
            this.flag = !this.flag;
            this.dateToLineChart = this.convertDateToLineChart(this.allDay, this.datePeriod.id, this.typeVisit.id)
            this.dateToLineChartVisits = this.convertDateToLineChart(this.allDay, this.datePeriod.id, 1)
            this.dateToLineChartSuccess = this.convertDateToLineChart(this.allDay, this.datePeriod.id, 2)
            setTimeout(() => this.flag = !this.flag, 0);

        },
        changePeriod(payload) {
            this.datePeriod = payload
            this.flag = !this.flag;
            this.dateToLineChart = this.convertDateToLineChart(this.allDay, this.datePeriod.id, this.typeVisit.id)
            this.dateToLineChartVisits = this.convertDateToLineChart(this.allDay, this.datePeriod.id, 1)
            this.dateToLineChartSuccess = this.convertDateToLineChart(this.allDay, this.datePeriod.id, 2)
            setTimeout(() => this.flag = !this.flag, 0);
        },
        changePeriod_v2(payload, period) {
            this.flag = !this.flag;
            this.datePeriod = payload
            this.getDate(this.datePeriod.name).then(()=>{
                setTimeout(()=>{this.flag = !this.flag},0)
            })

        },
        changePeriod_v3(payload, period) {
            this.flag = !this.flag;
            this.datePeriod = payload
            this.statistic_v3(this.datePeriod.pluck).then(()=>{
                setTimeout(()=>{this.flag = !this.flag}, 0)
            })
        },
        getLastDayOfMonth(year, month) {
            let date = new Date(year, month + 1, 0);
            return date.getDate();
        },
        async loadingStatistics() {
            return new Promise((resolve, reject) => {
                const id = this.$route.params.id
                this.$store.dispatch('contentById', {id, full: true, non_edit: true})
                    .then(resp => {
                            if (resp.status === 200) {
                                const visits = resp.data.visits
                                this.vis = visits
                                let countSuccess = 0
                                let allDate = []
                                visits.map(visit => {
                                    let date = new Date(visit.created_at)
                                    if (visit.result) {
                                        countSuccess++
                                    }
                                    allDate.push({date, success: visit.result ?? false})
                                })
                                resolve(allDate)
                                // this.stat = [visits.length - countSuccess, countSuccess]
                            }
                            if (resp.status === 404) {
                                this.$router.push('/not-found');
                            }
                        }
                    )
            })

        },

        dateHelper(date) {
            const Day = date.getDate()
            const Mounth = date.getMonth()
            const Year = date.getFullYear()
            return `${Mounth + 1}/${Day}/${Year}`

        },

        periodHelper(period) {
            if (period === 1) {
                return 1
            }
            if (period === 2) {
                return 2
            }
            if (period === 3) {
                return 6
            }
            return 1
        },
        convertDateToLineChart(allDate, period, type) {
            const newDate = allDate

            const now = new Date()
            const nowDay = now.getDate()
            const nowMounth = now.getMonth()
            const nowYear = now.getFullYear()


            let datesArrayVisit = []

            let toMounth = this.periodHelper(period)
            for (let mounth = 0; mounth < toMounth; mounth++) {
                let lastDayMounth = this.getLastDayOfMonth(nowMounth - mounth, nowYear)
                for (let i = 1; i <= lastDayMounth; i++) {
                    /*let m = nowMounth + 1 - mounth;
                    let d = i
                    let y = nowYear
                    let format = `${m}/${d}/${y}`*/
                    // console.log('format',format)
                    // toMounth instead magic-const 1
                    let dateString = Date.parse(`${nowMounth + toMounth - mounth}/${i}/${nowYear}`)
                    /*console.log('dateString: ', dateString)
                    console.log('nowMounth: ', nowMounth)
                    console.log('mounth: ', mounth)
                    console.log('i:', i)
                    console.log('nowYear: ', nowYear)
                    console.log('==================')*/
                    if (!isNaN(dateString)) {
                        datesArrayVisit.push({date: new Date(dateString), data: 0})
                    }
                }
            }

            datesArrayVisit.sort(function (a, b) {
                var dateA = new Date(a.date), dateB = new Date(b.date)
                return dateA - dateB //сортировка по возрастающей дате
            })
            datesArrayVisit.forEach((day, idx) => {
                allDate.forEach(item => {
                    if (this.dateHelper(day.date) === this.dateHelper(item.date)) {
                        if (type === 1) {
                            datesArrayVisit[idx].data++
                        }
                        if (type === 2) {
                            if (item.success) {
                                datesArrayVisit[idx].data++
                            }
                        }
                    }

                })
            })

            datesArrayVisit.map((day, idx) => {
                datesArrayVisit[idx] = {date: day.date.getDate(), data: day.data}
            })
            return datesArrayVisit
        }
    }
};
